import { Link } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { useState, useEffect } from "react";

const Protect = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { accessToken } = useAuthStore();

  useEffect(() => {
    if (!accessToken) {
      setIsOpen(true);
    }
  }, [accessToken]);

  const handleClose = () => {
    setIsOpen(false);
    window.location.href = "/clients/signin";
  };

  if (accessToken) {
    return children;
  }

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white text-gray-800 rounded-lg shadow-lg w-96 max-w-[90vw]">
            {/* Header */}
            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-700">
              <h2 className="text-lg font-semibold">Authentication Required</h2>
              <Link
                to={'/'}
                className="text-gray-400 hover:text-gray-200 text-2xl leading-none"
              >
                ×
              </Link>
            </div>

            {/* Body */}
            <div className="px-6 py-4">
              <p>You must be logged in to access this page.</p>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-700 flex justify-end">
              <button
                onClick={handleClose}
                className="bg-[#174568] hover:bg-gray-800 text-white font-medium px-4 py-2 rounded transition"
              >
                Go to Login
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Protect;